import Learning from '~/common/api/learning';

export const MODULES_GET_CLEARXP_MODULE_ANSWER_SUCCESS = 'MODULES_GET_CLEARXP_MODULE_ANSWER_SUCCESS';
export const MODULES_GET_CLEARXP_MODULE_ANSWER_FAILURE = 'MODULES_GET_CLEARXP_MODULE_ANSWER_FAILURE';

export const getClearXpModuleAnswer = (moduleId, userId) => {
  return (dispatch) => {

    const activityId = encodeURIComponent(moduleId);
    const promise = new Promise((resolve, reject) => {
      Learning.get(`/lessons/${userId}/lesson/${activityId}`).then(
        (res) => {
          dispatch({
            type: MODULES_GET_CLEARXP_MODULE_ANSWER_SUCCESS,
            data: {
              activity_completion_info: res.activity_completion_info,
              answers: res.answers
            },
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: MODULES_GET_CLEARXP_MODULE_ANSWER_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  }
};

export const reducer = (state, action) => {
  switch (action.type) {
    case MODULES_GET_CLEARXP_MODULE_ANSWER_SUCCESS:
      const newState = {
        ...state,
        clearXpCompletionInfo: action.data.activity_completion_info,
        clearXpAnswer: action.data.answers,
      };
      return newState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/modules/redux/getClearXPModuleAnswer.js